<template>
  <div class="pt-5 position-relative view-wrapper" :class="(showSpin) ? 'spin' : ''">
		<div class="product-instructions">
			<LocalizedLink to="/"  class="close-detail position-absolute"></LocalizedLink>

			<arrow arrow-class="arrow-left" target="/drive-thru"></arrow>
			<arrow arrow-class="arrow-right" target="/kitchen"></arrow>

      <div class="p-border">
        <div class="product-copy-container" v-if="!triggerClose">
          <div class="product-title p-spin" v-html="$t('vanity_screen.title')"></div>
          <div class="product-inst" v-html="$t('vanity_screen.content')"></div>
          <div @click="setShowSpin(true)" class="btn-spin">
            <div class="btn-spin-container">
              <img src="../../assets/imgs/sm-spin.png" class="mr-1"><div v-html="$t('shared.spin_button')"></div>
            </div>
          </div>
        </div>
        <div class="product-copy-container" v-if="triggerClose">
          <div class="product-title p-spin" v-html="$t('bathroom_screen.title')"></div>
          <div class="product-inst" v-html="$t('bathroom_screen.content')"></div>
          <div @click="setShowSpin(true)" class="btn-spin">
            <div class="btn-spin-container">
              <img src="../../assets/imgs/sm-spin.png" class="mr-1"><div v-html="$t('shared.spin_button')"></div>
            </div>
          </div>
        </div>
      </div>
		</div>

		<div ref="product" class="product-detail position-absolute">
      <div class="product-blur-top"></div>
      <div class="product-blur-bottom"></div>

		</div>
    <div ref="tooltip" class="tooltip-b" v-html="$t('vanity_screen.speech_bubble')"></div>

  <SpinHouse 
      v-if="showSpin" 
      :triggerClose="triggerClose"
      :sprite="spriteSheet"
      @set-showspin="setShowSpin()"
      :anims="dinerSpriteAnims"
      :stageSize="stageSize"
    />

  </div>  
</template>

<script>
import Arrow from "../Arrow";
import LocalizedLink from '@/components/LocalizedLink'

import SpinHouse from "../particle/SpinHouse"
import vanitySprite from '../../assets/imgs/spins/vanity.png'

export default {
  name: "VanityPage",
  components: {
		Arrow,
		LocalizedLink,
    SpinHouse
	},
  data () {
		return {
      triggerClose: false,
      showSpin: false,
      spriteSheet: vanitySprite,
      dinerSpriteAnims: {
        idle: [
          // x, y, width, height (4 frames)
          0, 0, 500, 413,
          500, 0, 500, 413,
          1000, 0, 500, 413,
          1500, 0, 500, 413,
          0, 413, 500, 413,
          500, 413, 500, 413,
          1000, 413, 500, 413,
          1500, 413, 500, 413,
          0, 826, 500, 413,
          // 500, 826, 500, 413,
          // 1000, 826, 500, 413,
          // 1500, 826, 500, 413,
          // 0, 1239, 500, 413,
          // 500, 1239, 500, 413,
          // 1000, 1239, 500, 413,
          // 1500, 1239, 500, 413,
        ],
        reverse: [
          0, 826, 500, 413,
          1500, 413, 500, 413,
          1000, 413, 500, 413,
          500, 413, 500, 413,
          0, 413, 500, 413,
          1500, 0, 500, 413,
          1000, 0, 500, 413,
          500, 0, 500, 413,
          0, 0, 500, 413,
        ]
      },
      stageSize: {
        width: 500,
        height: 413
      }
		}
	},  
  mounted() {
    this.panBackground(this.$refs.product, 100, 75);
    this.floatTooltip(this.$refs.tooltip);
  },
  methods: {
    setShowSpin(val) {
      this.triggerClose = !this.triggerClose;
      if(!val || val === undefined) this.triggerClose = false;
      console.log('showSpin', val);
      this.showSpin = val;
    },
  }
}
</script>

<style lang="scss" scoped>
.product-blur-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  // height: calc(60vh - var(--vh-offset, 0px));
  height: 350px;
  @media screen and (max-width: 768px) {
    @supports (backdrop-filter: none) {
      -webkit-backdrop-filter: blur(4px);
      backdrop-filter: blur(4px);  
    }
  }
}
.product-blur-bottom {
  position: absolute;
  top: 580px;
  left: 0;
  width: 100%;
  height: calc(var(--vh, 1vh) * 25);
  // filter: blur(70px);
  @media screen and (max-width: 768px) {
    @supports (backdrop-filter: none) {
    background: rgba(0, 0, 0, 0.4);
      -webkit-backdrop-filter: blur(4px);
      backdrop-filter: blur(4px);  
    }
  }
}
.detail-view{ 
  .product-detail {
    background-position: -360px 55px;
    @media (min-width: 729px) {
      background-position: -160px 225px;
    }
  }
}
.tooltip-b {
  width: 150px;
  padding: 12px 10px;
  background-color: #fff;
  position: absolute;
  font-family: ProximaSoft;
  font-size: 16px;
  bottom: calc(var(--vh, 1vh) * 5);
  left: 12vw;
  color: #48c0ba;
  font-weight: bold;
  text-align: center;
  line-height: 18px;

  &:before {
    content: "";
    position: absolute;
    bottom: 100%;
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-bottom: 27px solid #fff;
    border-right: 1px solid transparent;
    right: 50px;
  }
  @media (min-width: 415px) and (max-width: 728px) {
    left: 50vw;
  }
  @media (min-width: 729px) {
    bottom: auto;
    top: calc(var(--vh, 1vh) * 75);
    left: 43%;
  }  
}
.house {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
